import { ErrorBoundary } from '@/components/ErrorBoundary';
import { PerformanceSummary } from '@/components/dashboard/PerformanceSummary';
import { OpenPositionsSummary } from '@/components/dashboard/OpenPositionsSummary';
import { RecentAlerts } from '@/components/dashboard/RecentAlerts';
import { PnlChart } from '@/components/dashboard/PnlChart';
import { PositionsByExpiration } from '@/components/dashboard/PositionsByExpiration';
import { CashHeldTile } from '@/components/dashboard/CashHeldTile';
import { CreditGoalTile } from '@/components/dashboard/CreditGoalTile';
import { DEFAULT_PERIOD, PERIOD_VALUES, type Period } from '@/components/analytics/periods';
import { useUrlParam } from '@/hooks/useUrlState';

export function DashboardPage() {
  // The P&L window is the one thing on this page you change, so it belongs in the URL.
  const [period, setPeriod] = useUrlParam<Period>('period', DEFAULT_PERIOD, PERIOD_VALUES);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
        <p className="text-sm text-gray-500 mt-1">Overview of your options trading performance</p>
      </div>

      <ErrorBoundary>
        <PerformanceSummary />
      </ErrorBoundary>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <ErrorBoundary>
            <PnlChart period={period} onPeriodChange={setPeriod} />
          </ErrorBoundary>
        </div>
        <div>
          <ErrorBoundary>
            <PositionsByExpiration />
          </ErrorBoundary>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-4 gap-6">
        <ErrorBoundary>
          <OpenPositionsSummary />
        </ErrorBoundary>
        <ErrorBoundary>
          <RecentAlerts />
        </ErrorBoundary>
        <ErrorBoundary>
          <CashHeldTile />
        </ErrorBoundary>
        <ErrorBoundary>
          <CreditGoalTile />
        </ErrorBoundary>
      </div>
    </div>
  );
}
